import { Routes, Route } from "react-router-dom";
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';

import About from "./pages/About";
import Home from "./pages/Home";
import Nopage from "./pages/Nopage";
import Search from "./pages/Search";
import Kids from "./pages/Kids";
import Mens from "./pages/Mens";
import Womens from "./pages/Womens";
import Cart from "./pages/Cart";
import Login from "./pages/Login";
import Test from "./pages/test";

function App() {
  return (
    <div className="App">
      <Navbar bg="primary" variant="dark" sticky="top">
        <Container>
          <Navbar.Brand href="/">
            <img
              src="/Spoura-logos_white.png"
              width="20%"
              style={{float: "left"}}
              className="d-inline-block align-top"
              alt=""
            />
          </Navbar.Brand>
          <Nav className="me-auto">
            <NavDropdown title="Shop" id="basic-nav-dropdown">
              <NavDropdown.Item href="/mens">Mens</NavDropdown.Item>
              <NavDropdown.Item href="/womens">Womens</NavDropdown.Item>
              <NavDropdown.Item href="/kids">Kids</NavDropdown.Item>
            </NavDropdown>
            <Nav.Link href="/search">Search</Nav.Link>
            <Nav.Link href="/about">About</Nav.Link>
            <Nav.Link href="/cart">Cart</Nav.Link>
            <Nav.Link href="/account">Account</Nav.Link>
          </Nav>
        </Container>
      </Navbar>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="about" element={<About />} />
        <Route path="*" element={<Nopage />} />
        <Route path="search" element={<Search />} />
        <Route path="kids" element={<Kids />} />
        <Route path="womens" element={<Womens />} />
        <Route path="mens" element={<Mens />} />
        <Route path="cart" element={<Cart />} />
        <Route path="account" element={<Login />} />
        <Route path="test" element={<Test />} />
      </Routes>
    </div>
  );
}

export default App;
